// Handwritten introduction pages (storytellers.handwritten_intro_url).
//
// The episode-processor Lambda stores the page in the website bucket
// (handwriting/<id>-<ts>.jpg), bakes the branded frame into a copy
// (handwriting/framed/<id>-<ts>.jpg) and saves the URL on the storyteller.
// The page is shrunk in the browser first so the request stays well under the
// Lambda's 6 MB payload limit; 2800 px is plenty for a handwritten page.

const MAX_SIDE = 2800;

export const framedHandwritingUrl = (url) =>
  url ? url.replace("/handwriting/", "/handwriting/framed/").replace(/\.(png|jpeg)$/i, ".jpg") : null;

const toJpegBase64 = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(img.src);
      resolve(canvas.toDataURL("image/jpeg", 0.9).split(",")[1]);
    };
    img.onerror = () => reject(new Error("Could not read the image"));
    img.src = URL.createObjectURL(file);
  });

export async function uploadHandwriting(apiUrl, storytellerId, file, env) {
  const image_b64 = await toJpegBase64(file);
  const resp = await fetch(`${apiUrl}/process-episode-job/handwriting`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ storyteller_id: storytellerId, image_b64, env }),
  });
  const result = await resp.json().catch(() => ({}));
  if (!resp.ok || !result.success) throw new Error(result.error || `HTTP ${resp.status}`);
  return result; // { handwritten_intro_url, framed_url }
}
